import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  let index = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'order',
  })

  return function onClick() {
    submit({ type: 'addActionInWait', index })
  }
}
